<template>
  <navigation-button
    :route="{ name: 'MyDeals', query: { category } }"
    :style-classes="`btn-anchor ${styleClasses}`"
    text="My Deals"
    :icon="icon"
    :display-badge="displayBadge"
    :badge-offset-x="badgeOffsetX"
    :badge-offset-y="badgeOffsetY"
    :badge-text="badgeText"
  />
</template>

<script>
import NavigationButton from '@/components/utils/buttons/navigation/NavigationButton';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faHandshake, faHandsHelping, faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons';

library.add([faHandshake, faHandsHelping, faHandHoldingUsd]);

export default {
  components: {
    NavigationButton,
  },
  props: {
    category: {
      type: String,
      default: 'in_progress',
    },
    displayBadge: Boolean,
    badgeOffsetX: [String, Number],
    badgeOffsetY: [String, Number],
    badgeText: [String, Number],
    styleClasses: String,
  },
  computed: {
    icon() {
      switch (this.category) {
        case 'in_progress':
          return 'handshake';
        case 'active':
          return 'hands-helping';
        case 'paid':
          return 'hand-holding-usd';
        default:
          return null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/navigation/DealsButton.vue